import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseDatatable";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { createMonthRedux } from "../../../actions/index";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "./loan.css";

export class MonthlyExpense extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.createMonthRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };
  clickActive = (event) => {
    document.querySelector(".nav-link").classList.remove("show");
    event.target.classList.add("show");
  };
  render() {
    const { open } = this.state;

    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="Loan" parent="expense history" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid ln-page">
          <Tabs>
            <TabList
              className="nav nav-tabs tab-coupon ln-tablist"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              <Tab className="nav-link ln-tab" onClick={(e) => this.clickActive(e)}>
                Loan Given
              </Tab>

              <Tab className="nav-link ln-tab" onClick={(e) => this.clickActive(e)}>
                Loan Taken
              </Tab>
            </TabList>
            <TabPanel>
              <div className="row">
                <div className="col-sm-12">
                  <div className="card ln-card">
                    <div className="card-header ln-card-header">
                      <h5 className="ln-card-title">
                        <i className="icofont-bill ln-card-icon"></i>
                        Loan Given
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="clearfix"></div>
                      <div id="basicScenario" className="product-physical">
                        <Datatable
                          startToggleModal={this.startToggleModal}
                          history={this.props.history}
                          multiSelectOption={false}
                          myData={this.props.allMonths}
                          pageSize={50}
                          pagination={true}
                          className="-striped -highlight"
                          type="expense"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="row">
                <div className="col-sm-12">
                  <div className="card ln-card">
                    <div className="card-header ln-card-header">
                      <h5 className="ln-card-title">
                        <i className="icofont-bill ln-card-icon"></i>
                        Loan Taken
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="clearfix"></div>
                      <div id="basicScenario" className="product-physical">
                        <Datatable
                          startToggleModal={this.startToggleModal}
                          history={this.props.history}
                          multiSelectOption={false}
                          myData={this.props.allMonths}
                          pageSize={50}
                          pagination={true}
                          className="-striped -highlight"
                          type="cashIn"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allMonths: state.admins.months,
  };
};

export default connect(mapStateToProps, { createMonthRedux })(MonthlyExpense);
